// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1OeOb","content":"styles_content__3Jvtf","messageContainer":"styles_messageContainer__3iY8a"};